import React, { Component } from "react";
import { Modal } from "react-responsive-modal";
import { Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import QRCode from "react-qr-code";
import { isDesktop } from "react-device-detect";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { formValidation } from "../../hoc/Shared/utility";

import StringInput from "../../components/Input/StringInput/StringInput";
import PasswordInput from "../../components/Input/PasswordInput/PasswordInput";
import NumberInput from "../../components/Input/NumberInput/NumberInput";

import { getGoogleAuthenticator, verifyGoogleAuthenticator } from "../../store/ducks/profile/actions";
import { getUserData } from "../../store/ducks/currentUser/actions";

import Authenticator from "./MobileEditPage/Authenticator";
export class BindingAuthenticator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,

      openVerificationModal: true,
      securityAns: "",
      password: "",
      showPassword: false,

      secretCode: "",
      url: "",
      errorMsg: [],
      formError: false,

      googleAuthSecretCode: "",
    };
  }

  componentDidMount() {
    this.props.getGoogleAuthenticator();
    
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { t } = this.props;

    if (nextProps.get_google_authenticator !== this.props.get_google_authenticator) {
      if (nextProps.get_google_authenticator.responseCode === 200) {
        this.setState({
          secretCode: nextProps.get_google_authenticator.data.secret_key,
          url: nextProps.get_google_authenticator.data.qr_code_url
        })
      } else {
        this.setState({ loading: false });
        Swal.fire({
          iconHtml: !isDesktop
            ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">'
            : "",
          title: t("global.sorry"),
          text: nextProps.get_google_authenticator.data.message[0],
          // icon: nextProps.register_data.data.msgType,
          icon: "error",
          confirmButtonText: t("global.ok"),
          customClass: !isDesktop
            ? {
              container: "swal-mobile-container sorry",
              icon: "swal-sorry-icon",
            }
            : [],
        });
      }
    }

    if (nextProps.verify_google_authenticator !== this.props.verify_google_authenticator) {
      if (nextProps.verify_google_authenticator.responseCode === 200) {
        Swal.fire({
          iconHtml: !isDesktop
          ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">'
          : "",
          icon: "success",
          title: t("global.success"),
          text: nextProps.verify_google_authenticator.message,
          confirmButtonText: t("global.ok"),
          customClass: !isDesktop
          ? {
            container: "swal-mobile-container sucess",
            icon: "swal-success-icon",
          }
          : [],
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
          });
      }  else if (nextProps.verify_google_authenticator.responseCode === 422) {
        this.setState({
          loading: false,
          touched: true,
          errorMsg: nextProps.verify_google_authenticator.message.input_error || [],
          formError: true,
        });
        Swal.close();
      } else {
        this.setState({ loading: false });
        Swal.fire({
          iconHtml: !isDesktop
            ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">'
            : "",
          title: t("global.sorry"),
          text: nextProps.verify_google_authenticator.data.message[0],
          // icon: nextProps.register_data.data.msgType,
          icon: "error",
          confirmButtonText: t("global.ok"),
          customClass: !isDesktop
            ? {
              container: "swal-mobile-container sorry",
              icon: "swal-sorry-icon",
            }
            : [],
        });
      }
    }


    return true;
  }

  verifyGoogleAuthenticator = (e) => {
    e.preventDefault();

    const { t } = this.props;

    Swal.fire({
      iconHtml: !isDesktop
        ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">'
        : "",
      title: t("global.confirmation"),
      text: t("global.would-you-like-to-proceed") + "?",
      // html: currencyNotification,
      icon: "warning",
      confirmButtonText: t("global.ok"),
      showDenyButton: true,
      denyButtonText: t("global.cancel"),
      customClass: !isDesktop
        ? {
          container: "swal-mobile-container confirmation",
          icon: "swal-confirmation-icon",
        }
        : [],
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          onOpen: () => {
            Swal.showLoading();
          },
        });


        let data = {};
        data.secret = this.state.googleAuthSecretCode;
        data.google_secret = this.state.secretCode;
        data.agent_id = this.props.currentUser.data.id;

        this.props.verifyGoogleAuthenticator(data);
      }
      
    });
  }

  //** COMPONENT **
  downloadAndInstall = (props) => {
    return (
      <div className="download-install">
        <h6>Download Method:</h6>
        <p>1. Scan QR Code</p>

        <div className="auth-qr-container mb-5">
          <div className="qr-body">
            <div className="qr-code">
              <QRCode size="158" value="Apple IOS" />
            </div>
            <button className="btn btn-gradient-blue">
              <Icon icon="uil:apple" />
              Apple IOS
            </button>
          </div>

          <div className="qr-body">
            <div className="qr-code">
              <QRCode size="158" value="Android" />
            </div>
            <button className="btn btn-gradient-blue">
              <Icon icon="uil:android" />
              Android
            </button>
          </div>
        </div>

        <p className="mb-5">
          2. If you cannot download it, you can search for “Google Authenticator” in the Apple Store, <br />
          or search for “Google Authenticator” in the Android App Store to download and install it.
        </p>
        <button className="btn btn-gradient-blue w-25 mb-5" onClick={props.nextStep}>
          Next
        </button>

        <div className="text-danger d-flex align-items-start">
          <span style={{ width: "0.75rem", height: "0.75rem" }}>
            <Icon className="me-1" icon="akar-icons:circle-alert-fill" />
          </span>
          <span>Tip: It has been downloaded and installed, click “Next” to continue</span>
        </div>
      </div>
    );
  };

  addSecretCode = (props) => {
    return (
      <div className="secret-code">
        <h6>Scan QR Code or Insert Code Manually:</h6>
        <p>Option 1: Scan QR Code</p>

        <div className="auth-qr-container mb-5">
          <div className="qr-body">
            <div className="qr-code">
              <QRCode size="158" value={this.state.url} />
            </div>
          </div>
        </div>

        <p className="mb-3">Option 2: Secret Code</p>
        <div className="input-group mb-5">
          <input className="form-control" value={props.secretCode} readOnly />
          <button className="btn btn-gradient-blue" onClick={props.copySecretCode}>
            COPY
          </button>
        </div>

        <h6>Additional Step:</h6>
        <p className="mb-5">
          Open Google Authenticator, click “+” in the upper right corner (bottom right corner for Android), select
          “Manually enter the key”, fill in any account name insert the secret code as above, you may also scan the QR
          code to add it automatically.
        </p>

        <div className="d-flex mb-5">
          <button className="btn btn-outline-blue w-25 me-2" onClick={props.prevStep}>
            Back
          </button>
          <button className="btn btn-gradient-blue w-25" onClick={props.nextStep}>
            Next
          </button>
        </div>

        <div className="text-danger d-block">
          <div className="d-flex align-items-start">
            <span style={{ width: "0.75rem", height: "0.75rem" }}>
              <Icon className="me-1" icon="akar-icons:circle-alert-fill" />
            </span>
            <p>Tips:</p>
          </div>
          <ol>
            <li>
              After the mobile phone is lost or the identity verification is uninstalled, the secret code can help you
              to find the authenticator, please keep it properly.
            </li>
            <li>
              For the safety of your account, please do not indicate the proxy account and proxy background address when
              binding.
            </li>
          </ol>
        </div>
      </div>
    );
  };

  googleAuth = (props) => {
    const { t } = this.props;
    console.log(this.state.errorMsg)
    formValidation("verify_google_authenticator_form");

    return (
      <div className="google-auth">
        <h6>Google Authenticator Secret Code</h6>
        <p className="mb-3">Secret Code</p>

        <form 
          class="forms-col needs-validation" 
          action="post" 
          name="verify_google_authenticator_form" 
          id="verify_google_authenticator_form" 
          noValidate onSubmit={this.verifyGoogleAuthenticator}>
      
        <div className="input-group mb-5 w-50">
         
          <StringInput
            className={`form-control ${this.state.errorMsg.secret && "was-validated is-invalid"}`}
            id="secret"
            inputType="number"
            onChange={this.updateGoogleAuthSecretCode}
            placeholder="Insert 6-Digits Google Authenticator Secret Code"
            errorMsg={this.state.errorMsg.secret || ""}
            formError={this.state.formError}
            required
            requiredMessage={t("validation.required")}
            value={this.state.googleAuthSecretCode}
            style={{ borderTopRightRadius: "0.375rem", borderBottomRightRadius: "0.375rem" }}
          />
        </div>

        <div className="d-flex mb-5">
          <button className="btn btn-outline-blue w-25 me-2" onClick={props.prevStep}>
            Back
          </button>
          <button 
            className={`btn btn-gradient-blue w-25 ${this.state.googleAuthSecretCode === "" ? `disabled` : ``}`} 
            type="submit" 
            form="verify_google_authenticator_form">
              Next
          </button>
        </div>

        </form>

        <div className="text-danger d-block">
          <div className="d-flex align-items-start">
            <span style={{ width: "0.75rem", height: "0.75rem" }}>
              <Icon className="me-1" icon="akar-icons:circle-alert-fill" />
            </span>
            <p>Tips:</p>
          </div>
          <ol>
            <li>
              After the mobile phone is lost or the identity verification is uninstalled, the secret code can help you
              to find the authenticator, please keep it properly.
            </li>
            <li>
              For the safety of your account, please do not indicate the proxy account and proxy background address when
              binding.
            </li>
          </ol>
        </div>
      </div>
    );
  };

  //** FUNTION **

  enterSecurityAns = (e) => {
    this.setState({
      securityAns: e.target.value,
    });
  };

  enterPaymentPass = (e) => {
    this.setState({
      password: e.target.value,
    });
  };

  toggleShowPass = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  nextStep = () => {
    this.setState({
      currentStep: this.state.currentStep + 1,
    });
  };

  prevStep = () => {
    this.setState({
      currentStep: this.state.currentStep - 1,
    });
  };

  toogleVerificationModal = () => {
    this.setState({
      openVerificationModal: !this.state.openVerificationModal,
    });
  };

  toggleRefresh = () => {
    var refreshBtn = document.getElementById("refresh-btn");
    refreshBtn.classList.add("spin");
    setTimeout(() => {
      refreshBtn.classList.remove("spin");
    }, 2500);
  };

  autheticatorReminder = (e) => {
    const { t } = this.props;
    e.preventDefault();

    this.setState({
      openVerificationModal: false,
    });

    Swal.fire({
      icon: "warning",
      title: t("global.confirmation"),
      html: t("profile.authenticator-msg"),
      confirmButtonText: "Ok",
      customClass: {
        popup: "mw-100",
        confirmButton: "w-50",
      },
    }).then((result) => {
      if (result.isConfirmed) {
      }
    });
  };

  copySecretCode = () => {
    const { t } = this.props;
    navigator.clipboard.writeText(this.state.secretCode);
    Swal.fire({
      iconHtml: isDesktop ? "" : '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
      icon: t("global.success"),
      title: t("profile.copied-success"),
      // timer: 1500,
      showConfirmButton: false,
      customClass: isDesktop
        ? {}
        : { container: "swal-mobile-container sucess", icon: "swal-success-icon", confirmButton: "w-75" },
    });
  };

  updateGoogleAuthSecretCode = (e) => {
    this.setState({
      googleAuthSecretCode: e.target.value,
    });
  };

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };
  render() {
    const { t } = this.props;
    const img = this.imageImport(
      require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/)
    );

    const fadeUp = keyframes`
    from {
    opacity: 0;
    transform: translate3d(0, 50px ,0);
    }

    to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
    }`;

    const steps = [
      { id: 1, label: "Download & Install" },
      { id: 2, label: "Add Secret Code" },
      { id: 3, label: "Enable Google Authenticator" },
    ];
    return (
      <>
        {isDesktop ? (
          <>
            {/* <Modal open={this.state.openVerificationModal} onClose={this.toogleVerificationModal} center>
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Security Verification</h4>
                  <p>For your account security, please perform security verification first.</p>
                </div>
                <div className="modal-body">
                  <form className="forms-col needs-validation" onSubmit={this.autheticatorReminder}>
                    <div>
                      <div className="d-flex align-items-center mb-1">
                        <label className="mb-0 me-1">Food</label>
                        <Icon className="refresh-btn" icon="fe:sync" id="refresh-btn" onClick={this.toggleRefresh} />
                      </div>
                      <StringInput
                        // className={`${this.props.errorMsg.mobile_no && "was-validated is-invalid"}`}
                        className="form-control"
                        type="text"
                        placeholder="Please enter secret answer"
                        name="securityAns"
                        defaultValue=""
                        value={this.state.securityAns}
                        onChange={(e) => this.setState({ securityAns: e.target.value })}
                        // minLength={contact_no_min_limits}
                        // maxLength={contact_no_max_limits}
                        // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                        // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                        required
                        // requiredMessage={t("validation.required")}
                        // errorMsg={this.props.errorMsg.mobile_no || ""}
                        // formError={this.props.formError}
                      />
                    </div>
                    <div className="mb-3">
                      <label>Payment Password</label>

                      <div className="input-group right has-validation">
                        <PasswordInput
                          showPwd={this.state.showPassword}
                          onChange={(e) => this.setState({ password: e.target.value })}
                          id="payment_password"
                          name="payment_password"
                          // className={`no-border form-control ${this.state.errorMsg.newPassword && 'was-validated is-invalid'}`}
                          className={`form-control`}
                          placeholder="Please enter payment password"
                          value={this.state.password}
                          minLength={6}
                          required
                          // requiredMessage={t("validation.required")}
                          // minLengthMessage={t("validation.minLength", { 0: 6 })}
                          // errorMsg={this.state.errorMsg.newPassword || ''}
                          formError={this.state.formError}
                          format={
                            <span className="input-group-text bg-white">
                              <button
                                type="button"
                                className="btn p-0"
                                onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                              >
                                {this.state.showPassword ? (
                                  <img src={img["eye.png"]} alt="show pwd" />
                                ) : (
                                  <img src={img["close-eye.png"]} alt="hide pwd" />
                                )}
                              </button>
                            </span>
                          }
                        />
                      </div>
                    </div>
                    <button className="btn btn-gradient-blue w-75 mx-auto" type="submit">
                      Submit
                    </button>
                    <Link className="text-center">Join Venture Consultation</Link>
                  </form>
                </div>
              </div>
            </Modal> */}
            <Reveal className="pf-fade-col auth-container" keyframes={fadeUp} duration={1000} triggerOnce>
              <div className="row g-3">
                <div className="col-12">
                  <div className="pd-card-col h-100">
                    <div className="d-flex align-items-center mb-5">
                      <button className="me-2 btn" onClick={this.props.backToPersonalDetails}>
                        <Icon icon="material-symbols:arrow-back-ios-rounded" />
                      </button>
                      <h4 className="mb-0">Binding Authenticator</h4>
                    </div>

                    <div className="pd-content px-5">
                      <div className="step-progress-bar mb-5">
                        {steps &&
                          steps.map((item, index) => (
                            <>
                              <div
                                key={index}
                                className={`step ${
                                  item.id < this.state.currentStep
                                    ? "completed"
                                    : item.id === this.state.currentStep
                                    ? "active"
                                    : ""
                                }
                  `}
                              >
                                {item.id < this.state.currentStep ? (
                                  <p className="step-done">
                                    <Icon icon="ic:baseline-check" />
                                  </p>
                                ) : (
                                  <p className="step-num">{item.id}</p>
                                )}
                                <p className="step-title">{item.label}</p>
                              </div>

                              {index + 1 !== steps.length && (
                                <hr className={`${item.id < this.state.currentStep && "active"}`} />
                              )}
                            </>
                          ))}
                      </div>
                      {this.state.currentStep === 1 ? (
                        <this.downloadAndInstall nextStep={this.nextStep} />
                      ) : this.state.currentStep === 2 ? (
                        <this.addSecretCode
                          secretCode={this.state.secretCode}
                          nextStep={this.nextStep}
                          prevStep={this.prevStep}
                          copySecretCode={this.copySecretCode}
                        />
                      ) : this.state.currentStep === 3 ? (
                        <this.googleAuth
                          nextStep={this.nextStep}
                          prevStep={this.prevStep}
                          googleAuthSecretCode={this.state.googleAuthSecretCode}
                          updateGoogleAuthSecretCode={this.updateGoogleAuthSecretCode}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          </>
        ) : (
          <Authenticator
            {...this.state}
            backToPersonalDetails={this.props.backToPersonalDetails}
            toggleRefresh={this.toggleRefresh}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            enterPaymentPass={this.enterPaymentPass}
            enterSecurityAns={this.enterSecurityAns}
            toggleShowPass={this.toggleShowPass}
            copySecretCode={this.copySecretCode}
            updateGoogleAuthSecretCode={this.updateGoogleAuthSecretCode}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { profile } = state;

  return {
    get_google_authenticator: profile.get_google_authenticator,
    verify_google_authenticator: profile.verify_google_authenticator,
    currentUser: state.currentUser,
  };
};

const mapDispatchToProps = {
  getGoogleAuthenticator,
  verifyGoogleAuthenticator,
  getUserData
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withNamespaces("translation")(BindingAuthenticator)));

